var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormationIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.525,
    height: 30.209,
    viewBox: "0 0 34.525 30.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_formation",
    "data-name": "picto formation",
    transform: "translate(-313 -434.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fomation",
    transform: "translate(313 434.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_235",
    "data-name": "Trac\\xE9 235",
    d: "M1133.116,218.357l-16.543-7.912a.723.723,0,0,0-.621,0l-16.543,7.912a.719.719,0,0,0,0,1.3l5.345,2.557v6.145a.719.719,0,0,0,.226.523,16.27,16.27,0,0,0,22.564,0,.719.719,0,0,0,.226-.523v-6.145l1.438-.688v7.7a2.144,2.144,0,0,0-.237,3.949l-1.875,5a.62.62,0,0,0-.014.094.715.715,0,0,0-.028.175.725.725,0,0,0,.032.156.638.638,0,0,0,.023.108l.006.014,0,.007a3.054,3.054,0,0,0,5.619,0l0-.007.007-.014a.743.743,0,0,0,.022-.109.719.719,0,0,0,.033-.155.764.764,0,0,0-.028-.175.62.62,0,0,0-.016-.094l-1.875-5a2.143,2.143,0,0,0-.237-3.949v-8.388l2.469-1.181a.719.719,0,0,0,0-1.3Zm-3.187,12.173a.715.715,0,0,1,.044,1.429c-.015,0-.029-.006-.044-.006s-.029.005-.044.006a.715.715,0,0,1,.044-1.429Zm0,8.616a1.612,1.612,0,0,1-1.366-.786l1.366-3.64,1.365,3.64A1.611,1.611,0,0,1,1129.928,239.146Zm-3.6-11.1a14.835,14.835,0,0,1-20.139,0V222.9l9.759,4.668a.725.725,0,0,0,.621,0l9.759-4.668Zm-10.069-1.921-14.877-7.115,14.877-7.115,14.876,7.115Z",
    transform: "translate(-1099 -210.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormationIconBlack);
export default __webpack_public_path__ + "static/media/formation-icon-black.7435ab9f74b892a6c6f98b019d4e3d6c.svg";
export { ForwardRef as ReactComponent };